import { useState } from 'react';
import { FiArrowUpRight, FiRefreshCw } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import CurrencyRevenueReport from './index';
import RevenuePeriodFilter, { periodLabel } from './RevenuePeriodFilter';
import ExpandableReport from 'components/PortalDashboard/ExpandableReport';

export function useRevenuePeriod() {
    const [period, setPeriod] = useState({ from: '', to: '', preset: 'all' });
    return { period, setPeriod, query: { from_date: period.from, to_date: period.to } };
}

export default function RevenueReportPanel({ result, period, setPeriod, publisher = false, ordersLink, compact = false }) {
    const { data, isLoading, isFetching, isError, refetch } = result;
    return <ExpandableReport title={publisher ? 'Earnings report' : 'Revenue report'} className={`revenue-report${compact ? ' revenue-report-compact' : ''}`}>{({ expanded, controls, expand, canExpand }) => <>
        <header className="revenue-header">
            <div><span className="revenue-eyebrow">{publisher ? 'Publisher earnings' : 'Financial overview'}</span>
                <h2>{publisher ? 'Earnings report' : 'Revenue report'}</h2>
                <p>{publisher ? 'Track your income, payments and remaining balance.' : 'Understand sales and Akello revenue across every currency.'}</p></div>
            <div className="portal-report-heading-actions">{ordersLink && <Link to={ordersLink} className="revenue-button">View orders <FiArrowUpRight aria-hidden="true" /></Link>}{controls}</div>
        </header>
        {compact ? <details className="portal-revenue-filters"><summary>Filter reporting period</summary><RevenuePeriodFilter period={period} onApply={setPeriod} /></details> : <RevenuePeriodFilter period={period} onApply={setPeriod} />}
        <div className="revenue-period-summary">
            <p>Showing <strong>{periodLabel(period)}</strong></p>
            <button type="button" className="revenue-refresh" onClick={() => refetch()} disabled={isFetching || isLoading}>
                <FiRefreshCw aria-hidden="true" /><span>{isFetching && !isLoading ? 'Refreshing…' : 'Refresh'}</span>
            </button>
        </div>
        <CurrencyRevenueReport compact={compact && !expanded} publisher={publisher} data={data?.data} period={period} isLoading={isLoading} isError={isError} retry={refetch} />
        {compact && !expanded && canExpand && <button type="button" className="portal-report-open" onClick={expand}>View full report <FiArrowUpRight aria-hidden="true" /></button>}
    </>}</ExpandableReport>;
}
